import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ConfirmDialog } from "primereact/confirmdialog";
import useAPIRequest from "../../../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../../../store/ui-context";
import { setLayoutDashboardTitle } from "../../../../../store/ui-slice";
import { useAPIGetJadwal } from "../api/api-get-jadwal";
import { useAPIGetDelListData } from "../api/api-get-del-list-data";
import extractUrlParams from "../api/extract-url-params";
import Filter from "./Filter";
import ListJadwal from "./ListJadwal";
import ListSedangProses from "./ListSedangProses";
import ListSelesai from "./ListSelesai";
import useIsMobile from "../../../../../hooks/useIsMobile";

const title = "Pengecekan Kendaraan Keluar / Masuk ( TRADO )";
const titleSmall = "Pengecekan Trado";


const CekKeluarMasukTradoArsipMain = () => {
  const isMobile = useIsMobile();
  const uiContext = useContext(UiContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { requestGet, requestDelete, loading } = useAPIRequest();

  // data state
  const [filterValue, setFilterValue] = useState({
    dari: new Date(),
    sampai: new Date(),
    data_kendaraan: undefined,
  });

  // API call
  const { listDataJadwalKeberangkatan, fetchListDataJadwalKeberangkatan } =
    useAPIGetJadwal({ uiContext, requestGet, filterValue });

  const { paging, setPaging, listData, fetchListData, deleteData, getFilter } =
    useAPIGetDelListData({
      uiContext,
      navigate,
      location,
      requestGet,
      requestDelete,
      loading,
      filterValue,
    });

  // first time initializations
  useEffect(() => {
    dispatch(
      setLayoutDashboardTitle({
        title: isMobile ? titleSmall : title,
      })
    );

    firstFetch();

    // // load filter data from url query "key"
    // const urlParams = new URLSearchParams(location.search);
    // const key = urlParams.get("key");
    // if (key) {
    //   decodeQueryParams(key).then((decodedKey) => {
    //     const urlParams = new URLSearchParams(decodedKey);
    //     const filterNew = urlParams.get("filter");
    //     const page = urlParams.get("page");
    //     const take = urlParams.get("take");
    //     if (filterNew && page && take) {
    //       const { filterText, filterObject } = decodeQueryParamsToObject({
    //         filterText: filterNew,
    //         configFilters: [
    //           {
    //             field: "tanggal_transaksi",
    //             type: "date_range",
    //           },
    //           {
    //             field: "kendaraan_id",
    //             alias: "kendaraan",
    //             type: "object",
    //           },
    //         ],
    //       });
    //       setFilterValue(filterObject);
    //       fetchListData({
    //         page,
    //         take,
    //         filter: filterText,
    //         filterObject,
    //       });
    //       fetchListDataJadwalKeberangkatan();
    //     }
    //   });
    // } else {
    //   fetchListData({
    //     page: paging.page,
    //     take: paging.take,
    //   });
    //   fetchListDataJadwalKeberangkatan();
    // }
  }, []);

  // other function section

  const firstFetch = async () => {
    const { page, take, filterValue: _filterValue } = await extractUrlParams(
      location
    );

    let filter = null;
    if (_filterValue) {
      setFilterValue(_filterValue);
      filter = getFilter(_filterValue);
    }

    fetchListData({ page, take, filter, filterValue: _filterValue });
    fetchListDataJadwalKeberangkatan(_filterValue);
  };

  // handle UI event section

  const handleOnReload = () => {
    // if (!filterValue.kendaraan) {
    //   uiContext.showErrorMsg("Error", "Kendaraan harus dipilih");
    //   return;
    // }

    fetchListData({
      page: paging.page,
      take: paging.take,
    });
    fetchListDataJadwalKeberangkatan();
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListData({ page: newPage, take: newTake, filter: paging.filter });
    fetchListDataJadwalKeberangkatan();
  };

  const handleOnClickNew = async () => {
    const urlParams = new URLSearchParams(location.search);
    const key = urlParams.get("key");
    let url = "/transaksi/cek-keluar-masuk-trado/berangkat/new";
    if (key) {
      const encodedKey = encodeURIComponent(key);
      url += `?key=${encodedKey}`;
    }
    if (isMobile) {
      navigate(url);
    } else {
      // open new tab
      window.open(url, "_blank");
    }
  };

  return (
    <div className={`col-start-start px-4 gap-4 w-100`}>
      <ConfirmDialog />

      <div></div>

      <Filter
        loading={loading}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        onReload={handleOnReload}
        onNew={handleOnClickNew}
      />

      <ListJadwal
        listDataJadwalKeberangkatan={listDataJadwalKeberangkatan}
        loading={loading}
      />

      <ListSedangProses
        listData={listData}
        paging={paging}
        loading={loading}
        handleOnPage={handleOnPage}
        deleteData={deleteData}
      />

      <ListSelesai
        listData={listData}
        paging={paging}
        loading={loading}
        handleOnPage={handleOnPage}
        deleteData={deleteData}
      />

      <div></div>
    </div>
  );
};

export default CekKeluarMasukTradoArsipMain;
